import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"

import Login from './pages/Login'
import Home from './pages/Home'
import Clone from './pages/Clone'
import Logs from './pages/Logs'
import Leads from './pages/Leads'   // Task036
import Cobros from './pages/Cobros' // Task007

function App() {
  return (
      <Router>
        <Switch>
          <Route exact path="/login">
            <Login />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/clone/:platformName">
            <Clone />
          </Route>
          <Route exact path="/logs">
            <Logs />
          </Route>
          <Route exact path="/leads">
            <Leads />
          </Route>
          <Route exact path="/cobros">
            <Cobros />
          </Route>
        </Switch>
      </Router>
  );
}

export default App;
